import fetch from './fetch';


export function getWxTicket(params) {
  return fetch('/jd-art/api/wechat/share-config', {
    data: params,
  })
}

export function login(params) {
  return fetch('/jd-art/api/wechat/oauth/callback', {
    data: params,
    withoutToken: true
  })
}

export function getExhibitList(params) {
  return fetch('/jd-art/api/exhibits/list-detail', {
    data: params,
  });
}

export function getExhibitDetail(id) {
  return fetch(`/jd-art/api/exhibits/get-exhibit?_id=${id}`);
}

export function getArtistDetail(id) {
  return fetch(`/jd-art/api/artists/get-artist?_id=${id}`);
}

export function recordVisit(targetType, targetId) {
  return fetch('/jd-art/api/misc/visit', {
    data: {
      targetType,
      targetId,
    },
  });
}

export function recordShare(targetType, targetId) {
  return fetch('/jd-art/api/misc/share', {
    data: {
      targetType,
      targetId,
    },
  });
}

export function getLikeStatus(params) {
  return fetch('/jd-art/api/misc/status', {
    data: params,
  });
}

export function doLike(params) {
  return fetch('/jd-art/api/misc/like', {
    data: params,
  });
}

export function doUnlike(params) {
  return fetch('/jd-art/api/misc/cancel', {
    data: params,
    method: 'PUT',
  });
}